import * as React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { NavigateFunction, useNavigate, useParams } from 'react-router-dom'

import {
  METADATA_ALIAS_BATCH_EDITING,
  METADATA_ALIAS_INDIVIDUAL_EDITING,
} from '@disco/constants/FeatureTypes'
import { sendMixpanelEvent } from '@disco/state-management/actions/AnalyticsActions'
import {
  initEditedTrack,
  updateEditedTrack,
} from '@disco/state-management/actions/ServerActions'
import * as ShortlistActions from '@disco/state-management/actions/ShortlistActions'
import {
  getFeatureData,
  makeIsFeatureEnabled,
} from '@disco/state-management/selectors/business'
import { getLocationBeforeTransitions } from '@disco/state-management/selectors/routing'
import {
  getShortlistById,
  makeGetShortlistTracks,
} from '@disco/state-management/selectors/shortlists'
import { getHideTrackMetadataMoreButton } from '@disco/state-management/selectors/user'
import {
  getCommonBasicMetadataFields,
  getCommonExtraMetadataFields,
} from '@disco/utils/commonMetadata'

import { METADATA_TAB_IDX } from 'pages/explorer/shortlists/save/playlist-save-modal/constants'

import ShortlistMetadataEdit from './ShortlistMetadataEdit'

function mapStateToProps(state, { params }) {
  const getShortlistTracks = makeGetShortlistTracks()
  const shortlist = getShortlistById(state, {
    id: params.shortlistId,
  })
  const tracks = getShortlistTracks(state, params)
  const commonMetadata = getCommonBasicMetadataFields(tracks)
  const commonExtraMetaData = getCommonExtraMetadataFields(
    tracks.map(t => t.metadata),
  )
  const { isTrial, isFeatureEnabled: individualEditingEnabled } =
    getFeatureData(state, {
      featureName: METADATA_ALIAS_INDIVIDUAL_EDITING,
    })
  const isFeatureEnabled = makeIsFeatureEnabled()
  const batchEditingEnabled = isFeatureEnabled(state, {
    featureName: METADATA_ALIAS_BATCH_EDITING,
  })
  return {
    shortlist,
    user: state.user,
    editedTrack: state.server.editedTrack,
    hideMoreButton: getHideTrackMetadataMoreButton(state),
    originalEditedTrackMetadata: { ...commonMetadata, ...commonExtraMetaData },
    isTrial,
    individualEditingEnabled,
    batchEditingEnabled,
    tabIndex: METADATA_TAB_IDX,
    location: getLocationBeforeTransitions(state),
  }
}

const mapDispatchToProps = {
  ...ShortlistActions,
  initEditedTrack,
  updateEditedTrack,
  sendMixpanelEvent,
}

// Define connector
const connector = connect(mapStateToProps, mapDispatchToProps)

// Infer props type from Redux
type PropsFromRedux = ConnectedProps<typeof connector>

// Own props interface
interface OwnProps {
  params: any
  navigate: NavigateFunction
  bottomRowRef: {
    current: HTMLElement | null | undefined
  }
  tabOpen: boolean
  updateArtwork: (...args: Array<any>) => any
}

// Component props = Redux props + own props
type Props = PropsFromRedux & OwnProps

const ConnectedShortlistMetadataEdit = connector(ShortlistMetadataEdit)

function ShortlistMetadataEditWithNavigate(props: Props) {
  const navigate = useNavigate()
  const params = useParams<{ shortlistId: string }>()

  return (
    <ConnectedShortlistMetadataEdit
      {...props}
      params={params as { shortlistId: string }}
      navigate={navigate}
    />
  )
}

export default ShortlistMetadataEditWithNavigate
export { ConnectedShortlistMetadataEdit }
